import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { SharedModule } from 'shared/shared.module';
import { ProductDetailsRoutingModule } from './product-details-routing.module';
import { ScorecardModule } from 'shared/scorecard/scorecard.module';

import { ProductDetailsComponent } from './product-details.component';
import { SegmentsContainerComponent } from './components/segments-container/segments-container.component';
import { PCDBModalComponent } from './components/pcdb-modal/pcdb-modal.component';
import { AppSummaryModalComponent } from './components/app-summary-modal/app-summary-modal.component';
import { CustomDropdownComponent } from './components/custom-dropdown/custom-dropdown.component';
import { SuggestedAttributesComponent } from './components/attributes/suggested-attributes/suggested-attributes.component';
import { SuggestedAttributesModalComponent } from './components/attributes/suggested-attributes-modal/suggested-attributes-modal.component';
import { PriceSheetsDropdownComponent } from './components/pricing/price-sheets-dropdown/price-sheets-dropdown.component';
import { AddAssetsModalComponent } from './components/digital-assets/add-assets-modal/add-assets-modal.component';
import { AssetsSearchComponent } from './components/digital-assets/assets-search/assets-search.component';
import { AssetsListsSearchComponent } from './components/digital-assets/assets-lists-search/assets-lists-search.component';

import { FitmentsSearchComponent } from './components/fitments/fitments-search/fitments-search.component';
import { AddFitmentModalComponent } from './components/fitments/add-fitment-modal/add-fitment-modal.component';
import { DefaultProductInfograficComponent } from './components/fitments/default-product-infografic/default-product-infografic.component';
import { FitmentEditFormComponent } from './components/fitments/fitment-edit-form/fitment-edit-form.component';
import { FitmentPanelComponent } from './components/fitments/fitment-panel/fitment-panel.component';
import { FitmentYmmSearchComponent } from './components/fitments/fitment-ymm-search/fitment-ymm-search.component';


// segments
import { BaseSegmentComponent } from './components/base/_base-segment.component';
import { BaseSegmentListComponent } from './components/base/_base-segment-list.component';
import { DetailsComponent } from './components/details/details.component';
import { OverviewComponent } from './components/overview/overview.component';
import { AttributesComponent } from './components/attributes/attributes.component';
import { DescriptionComponent } from './components/description/description.component';
import { DigitalAssetsComponent } from './components/digital-assets/digital-assets.component';
import { FitmentsComponent } from './components/fitments/fitments.component';
import { InterchangesComponent } from './components/interchanges/interchanges.component';
import { KitsComponent } from './components/kits/kits.component';
import { MarketingComponent } from './components/marketing/marketing.component';
import { PackagesComponent } from './components/packages/packages.component';
import { ExtendedInformationComponent } from './components/packages/extended-information/extended-information.component';
import { PricingComponent } from './components/pricing/pricing.component';
import { CustomFieldsComponent } from './components/custom-fields/custom-fields.component';

// scorecards
import { ScorecardsTabComponent } from './components/segments-scorecard/scorecards-tab/scorecards-tab.component';
import { BaseScorecardComponent } from './components/segments-scorecard/base/_base-scorecard.component';
import { BaseScorecardListComponent } from './components/segments-scorecard/base/_base-scorecard-list.component';
import { DetailsScorecardComponent } from './components/segments-scorecard/details-scorecard/details-scorecard.component';
import { OverviewScorecardComponent } from './components/segments-scorecard/overview-scorecard/overview-scorecard.component';
import { DescriptionScorecardComponent } from './components/segments-scorecard/description-scorecard/description-scorecard.component';
import { AttributesScorecardComponent } from './components/segments-scorecard/attributes-scorecard/attributes-scorecard.component';
import { PricingScorecardComponent } from './components/segments-scorecard/pricing-scorecard/pricing-scorecard.component';
import { KitsScorecardComponent } from './components/segments-scorecard/kits-scorecard/kits-scorecard.component';
import { InterchangesScorecardComponent } from './components/segments-scorecard/interchanges-scorecard/interchanges-scorecard.component';
// eslint-disable-next-line max-len
import { DigitalAssetsScorecardComponent } from './components/segments-scorecard/digital-assets-scorecard/digital-assets-scorecard.component';
import { PackagesScorecardComponent } from './components/segments-scorecard/packages-scorecard/packages-scorecard.component';
import { FitmentsScorecardComponent } from './components/segments-scorecard/fitments-scorecard/fitments-scorecard.component';
import { MarketingScorecardComponent } from './components/segments-scorecard/marketing-scorecard/marketing-scorecard.component';
import { CustomFieldsScorecardComponent } from './components/segments-scorecard/custom-fields-scorecard/custom-fields-scorecard.component';

import { LogsService } from 'shared/logs/logs.service';
import { AttributesService } from './components/attributes/attributes.service';
import { SuggestedAttributesService } from './components/attributes/suggested-attributes/suggested-attributes.service';
import { PricingScorecardService } from './components/segments-scorecard/pricing-scorecard/pricing-scorecard.service';
import { FitmentsScorecardService } from './components/segments-scorecard/fitments-scorecard/fitments-scorecard.service';


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        DragDropModule,
        ProductDetailsRoutingModule,
        SharedModule,
        ScorecardModule,
    ],
    declarations: [
        ProductDetailsComponent,
        SegmentsContainerComponent,
        BaseSegmentComponent,
        BaseSegmentListComponent,
        DetailsComponent,
        OverviewComponent,
        AttributesComponent,
        DescriptionComponent,
        DigitalAssetsComponent,
        FitmentsComponent,
        InterchangesComponent,
        KitsComponent,
        MarketingComponent,
        PricingComponent,
        PackagesComponent,
        ExtendedInformationComponent,
        CustomFieldsComponent,
        ScorecardsTabComponent,
        BaseScorecardComponent,
        BaseScorecardListComponent,
        DetailsScorecardComponent,
        OverviewScorecardComponent,
        DescriptionScorecardComponent,
        PCDBModalComponent,
        AppSummaryModalComponent,
        CustomDropdownComponent,
        SuggestedAttributesComponent,
        SuggestedAttributesModalComponent,
        AttributesScorecardComponent,
        PriceSheetsDropdownComponent,
        PricingScorecardComponent,
        KitsScorecardComponent,
        InterchangesScorecardComponent,
        AddAssetsModalComponent,
        AssetsSearchComponent,
        AssetsListsSearchComponent,
        DigitalAssetsScorecardComponent,
        PackagesScorecardComponent,
        FitmentsSearchComponent,
        AddFitmentModalComponent,
        DefaultProductInfograficComponent,
        FitmentEditFormComponent,
        FitmentPanelComponent,
        FitmentYmmSearchComponent,
        FitmentsScorecardComponent,
        MarketingScorecardComponent,
        CustomFieldsScorecardComponent,
    ],
    exports: [
        AddAssetsModalComponent
    ],
    providers: [
        LogsService,
        AttributesService,
        SuggestedAttributesService,
        PricingScorecardService,
        FitmentsScorecardService,
    ]
})
export class ProductDetailsV2Module {}
